import { EventTypeEnum, EventStreamingTypeEnum } from "@prisma/client";
import dayjs from "dayjs";
import { useState } from "react";
import { VodContentData } from "../useVods/types";
const getInitialFormValues = (content?: VodContentData) => {
  const initialValues = content?.lesson
    ? {
        ...content,
        title: content.title,
        description: content.description,
        instructor: content.lesson.instructor,
        duration: content?.lesson?.duration
          ? parseFloat(content?.lesson?.duration) / 60
          : 0,
        streamingUrl: content?.lesson?.streamingUrl || "",
      }
    : {};
  return initialValues;
};

const getInitialState = (
  mode?: "create" | "edit",
  content?: VodContentData,
  spaceId?: string
) => {
  let initialData;
  if (content?.lesson) {
    initialData = {
      color: content?.color ?? undefined,
      price: content.price ?? 0,
      credits: content.credits ?? 0,
      taxRates: content.taxRates?.map((el) => el.id) ?? [],
      spaceId: content?.spaceId || "",
      chapterId: content?.chapterId || "",
      isPublic: content?.lesson?.public ?? true,
      linkedProducts: content?.linkedProducts?.map((el) => el.id) || [],
    };
  } else {
    initialData = {
      color: undefined,
      price: 0,
      credits: 0,
      spaceId: spaceId ?? "",
      taxRates: [] as string[],
      chapterId: "",
      isPublic: true,
      linkedProducts: [] as string[],
    };
  }
  return initialData;
};

const useVodFormValues = (defaultValues?: VodContentData) => {
  return getInitialFormValues(defaultValues);
};
const useVodFormState = (
  mode: "create" | "edit",
  defaultValues?: VodContentData,
  spaceId?: string
) => {
  return useState(getInitialState(mode, defaultValues, spaceId));
};

export { useVodFormState, useVodFormValues };
